// extracted by mini-css-extract-plugin
module.exports = {"container":"SliderRail-module--container--PItC8","rail":"SliderRail-module--rail--1WzdJ"};